import { render } from "./RandomizationOptions.vue?vue&type=template&id=1051c8ea"
import script from "./RandomizationOptions.vue?vue&type=script&lang=js"
export * from "./RandomizationOptions.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/marvel-lcg-randomizer/marvel-lcg-randomizer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__